/**
 * The product identity for the SPA — the same brand/brand.json the server
 * reads (server/lib/brand.js). Colors reach CSS through the vite brand plugin.
 */
import brand from '../brand/brand.json'

/** Is an optional product feature (brand.features.<name>) switched on? Unlisted = on. */
export function brandFeature(name) {
  return brand.features?.[name] !== false
}

export default brand
